import { CSSProperties } from "react"

import { toPixels } from "shared/lib/layoutUtils"

function getLevelDistanceColumnWidth(level: number): string {
  return toPixels(level * 16 + 2)
}

// The selection preset drops the icon columns entirely, while `hideIcons`
// keeps them in the grid at zero width.
function getIconColumnWidth(isSelection: boolean, hideIcons?: boolean): string {
  if (isSelection) return ""
  return hideIcons ? "0" : "24px"
}

export function getProductPositionTableProductPositionColumnSizes({
  level = 0,
  hideVariantKey,
  hideQuantity,
  hideIcons,
  showClarificationRequestColumn,
  hideMenu,
  showSelectionCheckbox,
  columnPreset = "default"
}: {
  level?: number
  hideVariantKey?: boolean
  hideQuantity?: boolean
  hideIcons?: boolean
  showClarificationRequestColumn?: boolean
  hideMenu?: boolean
  showSelectionCheckbox?: boolean
  columnPreset?: "default" | "selection"
}): CSSProperties {
  const isSelection = columnPreset === "selection"
  const levelDistanceColumnWidth = getLevelDistanceColumnWidth(level)
  const positionColumnWidth = "52px"
  const collapseButtonColumnWidth = "44px"
  const checkboxColumnWidth = showSelectionCheckbox ? "44px" : ""
  const crColumnWidth = showClarificationRequestColumn ? "44px" : ""
  const productNameColumnWidth = hideVariantKey
    ? "1fr"
    : toPixels(200 - level * 16)
  const iconColumnWidth = getIconColumnWidth(isSelection, hideIcons)
  const variantKeyColumnWidth = hideVariantKey ? "" : "auto"
  const quantityColumnWidth = isSelection || hideQuantity ? "" : "60px"
  const menuColumnWidth = isSelection || hideMenu ? "" : "44px"

  return {
    gridTemplateColumns:
      `${levelDistanceColumnWidth} ${checkboxColumnWidth} ${collapseButtonColumnWidth} ${positionColumnWidth} ${crColumnWidth} ${productNameColumnWidth} ${variantKeyColumnWidth}
      ${quantityColumnWidth} ${iconColumnWidth} ${iconColumnWidth} ${iconColumnWidth} ${iconColumnWidth} ${menuColumnWidth} 8px`
        .replace(/\s+/g, " ")
        .trim()
  }
}

export function getProductPositionTableRoomColumnSizes({
  level = 0,
  hideIcons,
  showClarificationRequestColumn,
  hideMenu,
  showSelectionCheckbox,
  columnPreset = "default"
}: {
  level?: number
  hideIcons?: boolean
  showClarificationRequestColumn?: boolean
  hideMenu?: boolean
  showSelectionCheckbox?: boolean
  columnPreset?: "default" | "selection"
}): CSSProperties {
  const isSelection = columnPreset === "selection"
  const levelDistanceColumnWidth = getLevelDistanceColumnWidth(level)
  const collapseButtonColumnWidth = "44px"
  const positionColumnWidth = "52px"
  const checkboxColumnWidth = showSelectionCheckbox ? "44px" : ""
  const crColumnWidth = showClarificationRequestColumn ? "44px" : ""
  const productNameColumnWidth = "1fr"
  const iconColumnWidth = getIconColumnWidth(isSelection, hideIcons)
  const menuColumnWidth = isSelection || hideMenu ? "" : "44px"

  return {
    gridTemplateColumns:
      `${levelDistanceColumnWidth} ${checkboxColumnWidth} ${collapseButtonColumnWidth}
    ${positionColumnWidth} ${crColumnWidth} ${productNameColumnWidth} ${iconColumnWidth} ${menuColumnWidth} 8px`
        .replace(/\s+/g, " ")
        .trim()
  }
}

export function getProductPositionTableProductPositionAddonColumnSizes({
  level = 0,
  hideVariantKey,
  showClarificationRequestColumn,
  showSelectionCheckbox
}: {
  level?: number
  hideVariantKey?: boolean
  hideQuantity?: boolean
  showClarificationRequestColumn?: boolean
  showSelectionCheckbox?: boolean
}): CSSProperties {
  const levelDistanceColumnWidth = getLevelDistanceColumnWidth(level)
  const collapseButtonColumnWidth = "44px"
  const positionColumnWidth = "52px"
  const checkboxColumnWidth = showSelectionCheckbox ? "44px" : ""
  const crColumnWidth = showClarificationRequestColumn ? "44px" : ""
  const productNameColumnWidth = hideVariantKey
    ? "1fr"
    : toPixels(200 - level * 16)
  const variantKeyColumnWidth = hideVariantKey ? "" : "auto"

  return {
    gridTemplateColumns:
      `${levelDistanceColumnWidth} ${checkboxColumnWidth} ${collapseButtonColumnWidth}
    ${positionColumnWidth} ${crColumnWidth} ${productNameColumnWidth} ${variantKeyColumnWidth}  8px`.trim()
  }
}
